import React from "react";
import { PackageOpen } from "lucide-react";

export default function EmptyState({ icon: Icon = PackageOpen, title, body, action, className = "" }) {
  return (
    <div className={`flex flex-col items-center justify-center rounded-2xl border border-dashed border-border bg-secondary/40 px-6 py-16 text-center ${className}`} data-testid="empty-state">
      <div className="mb-4 grid h-16 w-16 place-items-center rounded-full bg-background shadow-soft">
        <Icon className="text-muted-foreground" size={28} />
      </div>
      {title && <h3 className="font-display text-lg font-bold text-ink">{title}</h3>}
      {body && <p className="mt-2 max-w-sm text-sm text-muted-foreground">{body}</p>}
      {action && <div className="mt-6">{action}</div>}
    </div>
  );
}
